import React from 'react';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import aboutImage from '../assest/images/aboutusimg.png';

function Testimonials() {

  return (
    <section id = "about" className="py-5 bg-light">
      <Container>
         <Row className="align-items-center mb-4">
          <Col md={6}>
            <img src={aboutImage} alt="About Hidden Paradise" className="img-fluid rounded" />
          </Col>
          <Col md={6}>
            <h2 className="mb-3">ESCAPIO TRAVELS</h2>
            <p>
              We are dedicated to providing tailor-made travel experiences in Sri Lanka. 
              Our tours are authentic, immersive, and designed to create unforgettable memories.
            </p>
            <Button

            variant="primary"
            className="rounded-pill px-4 py-2 shadow-sm"
            onClick={() =>
            window.open(

              "https://mail.google.com/mail/?view=cm&fs=1&to=info@escapiotravels.com&su=Inquiry%20about%20Escapio%20Travels&body=Hello,%20I%20would%20like%20to%20know%20more%20about%20your%20travel%20packages."

    )
  }
>
  Email Us
</Button>


        



            
          </Col>
        </Row>
      <h3 className="text-center mb-4">𝐖𝐡𝐲 𝐂𝐡𝐨𝐨𝐬𝐞 𝐔𝐬...</h3>  
      <Row>
         <Col md={6} lg={3} className="mb-3">
         <Card className='text-center-h100-p3'>
          <Card.Body>Tailor-made packages designed to meet individual needs </Card.Body>
         </Card>
         </Col>
         <Col md={6} lg={3} className="mb-3">
         <Card className='text-center-h100-p3'>
          <Card.Body>Authentic and immersive Sri Lankan experiences  </Card.Body>
         </Card>
         </Col>
         <Col md={6} lg={3} className="mb-3">
         <Card className='text-center-h100-p3'>
          <Card.Body>Extensive knowledge of hidden destinations & professional tour guides  </Card.Body>
         </Card>
         </Col>
          <Col md={6} lg={3} className="mb-3">
         <Card className='text-center-h100-p3'>
          <Card.Body>Commitment to sustainable tourism practices </Card.Body>
         </Card>
         </Col>


      </Row>
      </Container>
    </section>
  );
}

export default Testimonials;
